import React from "react";
import { TooltipIcon } from "../../../../../../components";

import { AuthResult, getEmailAuthVerdict } from "./utils";
import styles from "./email.module.scss";
import { AUTH_VERDICT, EMAIL_AUTH_ICON_MAP } from "./consts";

interface AuthResultProps {
  authResults: AuthResult;
  fullAuthHeader: string;
}

interface EmailAuthIconProps {
  authResult: string[];
  authVerdict: AUTH_VERDICT;
  fullAuthHeader: string;
}
const EmailAuthIcon: React.FC<EmailAuthIconProps> = ({
  authResult,
  authVerdict,
  fullAuthHeader
}) => (
  <span className={styles.email_auth_counters}>
    <TooltipIcon
      icon={EMAIL_AUTH_ICON_MAP[authVerdict]}
      message={fullAuthHeader || "No email authentication results found"}
      className={"k-pdf-email-box-right-margin k-pdf-push-left"}
    />{" "}
    ({authResult.length})
  </span>
);

export const EmailAuthResults: React.FC<AuthResultProps> = ({
  authResults,
  fullAuthHeader
}) => {
  const authVerdict = {
    dkim: getEmailAuthVerdict(authResults.dkim),
    spf: getEmailAuthVerdict(authResults.spf),
    dmarc: getEmailAuthVerdict(authResults.dmarc)
  };

  return (
    <span className={styles.email_auth_counters}>
      <EmailAuthIcon
        authResult={authResults.dmarc}
        authVerdict={authVerdict.dmarc}
        fullAuthHeader={fullAuthHeader}
      />
      <span>/</span>
      <EmailAuthIcon
        authResult={authResults.dkim}
        authVerdict={authVerdict.dkim}
        fullAuthHeader={fullAuthHeader}
      />
      <span>/</span>
      <EmailAuthIcon
        authResult={authResults.spf}
        authVerdict={authVerdict.spf}
        fullAuthHeader={fullAuthHeader}
      />
    </span>
  );
};
